import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'

//Actions
import { setClientIsUnsubscribedFromCustomer } from '../../../../actions/client'

// Selectors
import { selectCustomerFirstName, selectCustomerPhotoUri } from '../../../../store/selectors/customerProfile'

// Components
import { Text, Button } from '../../..'
import { SlideOnMount } from '../../Animations'
import Avatar from '../../Avatar'

// Styles
import styles from './UnsubscribedFromCustomer.module.scss'

// Assets
import EnvelopeWithLetterHB from './assets/EnvelopeWithLetterHB.svg'

const PreferencesPanel = () => {
  const dispatch = useDispatch()

  const customerFirstName = useSelector(selectCustomerFirstName)
  const customerPhoto = useSelector(selectCustomerPhotoUri)

  const handleSubscribeToCustomer = () => dispatch(setClientIsUnsubscribedFromCustomer({ setTo: false }))

  return (
    <SlideOnMount>
      <div className={styles.unsubscribedFromCustomerHeader}>
        <div className={styles.avatarAndEnvelope}>
          <Avatar src={customerPhoto} className={styles.avatar} />
          <div className={styles.envelopeWrapper}>
            <EnvelopeWithLetterHB />
          </div>
        </div>
        <Text size='l' variant='neutralCool' variantCount='900'>
          <FormattedMessage
            id='Preferences.panel.unsubscribedFromCustomer.title'
            defaultMessage='You have successfully unsubscribed from all Homebot emails from {customerFirstName}'
            values={{
              customerFirstName: customerFirstName
            }}
          />
        </Text>
      </div>
      <Text size='l' variant='neutralCool' variantCount='900'>
        <FormattedMessage
          id='Preferences.panel.unsubscribedFromCustomer.change.title'
          defaultMessage='Change your mind?'
        />
      </Text>
      <Text variant='neutralCool' variantCount='700'>
        <FormattedMessage
          id='Preferences.panel.unsubscribedFromCustomer.change.subTitle'
          defaultMessage='Re-subscribe to manage your email preferences'
        />
      </Text>
      <Button
        secondary
        className={styles.subscribeButton}
        data-qa='subscribeToCustomerButton'
        onClick={handleSubscribeToCustomer}
      >
        <FormattedMessage id='Preferences.panel.unsubscribedFromCustomer.subscribe' defaultMessage='Subscribe' />
      </Button>
    </SlideOnMount>
  )
}

export default PreferencesPanel
